import { DoughnutWidgetErrorBoundary } from 'src/dashboard/Componets/DoughnutWidgetErrorBoundary';

import { Widget } from 'src/dashboard/Componets/Widget';
import { DoughnutChartWithUserSelectAndSuspenseConatiner } from 'src/common/components/Graphs/common/Graphs/DoughnutChartWithSelectSuspense';

type DoughnutWidgetProps = {
  accountRef: string | null;
  children: (accountRef: string) => React.ReactNode;
  title: string;
};

export const DoughnutChartWidget = ({ accountRef, children, title }: DoughnutWidgetProps) => {
  return (
    <DoughnutWidgetErrorBoundary title={title} key={accountRef}>
      <Widget title={title}>
        <DoughnutChartWithUserSelectAndSuspenseConatiner accountRef={accountRef}>
          {children}
        </DoughnutChartWithUserSelectAndSuspenseConatiner>
      </Widget>
    </DoughnutWidgetErrorBoundary>
  );
};
